export type Attachment = {
  id: string;
  name: string;
  fileUrl: string;
  localSrc: string;
  size: number;
  type: string;
  uuid: string;
};
